import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

class TrainOperationInfo extends React.Component {
  static propTypes = {
    themeName: PropTypes.string.isRequired,
    notifications: PropTypes.array.isRequired,

    closeTrainOperation: PropTypes.func.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  async componentDidMount() {
    const { fetchNotifications } = this.props
    await fetchNotifications()

    this.props.closeTrainOperation()
  }

  // ヘッダー
  renderHeader(lineName) {
    const { themeName } = this.props
    const name = lineName == "nankai" ? "南海線" : "高野線"

    return (
      <div className="c-Modal-header">
        <p className="c-Modal-headerTitle">列車運行状況（{name}）</p>
      </div>
    )
  }

  renderOperationInfo(notification){

    return (
      <li key={notification.title} className="c-Modal-operationInfoItem">
        <p className="c-Modal-operationInfoTitle">
          <span>{notification.title}</span>
        </p>
        <p className="c-Modal-operationInfoText">
          {notification.content}
        </p>
      </li>
    )
  }

  // 列車運行状況の表示
  renderModalBody() {
    const { notifications } = this.props
    const { lineName } = this.props.match.params
    const name = lineName == "nankai" ? "南海線" : "高野線"

    var infos = notifications.filter(notification =>
      notification.line == name
    )

    return (
      <div className="c-Modal-body">
        <ul className="c-Modal-operationInfoList">
          {infos.map(notification => this.renderOperationInfo(notification))}
        </ul>
      </div>
    )
  }

  infoClick = () => {
    const { lineName } = this.props.match.params

    var name = ""
    var url = ""
    var referrerHash = ""
    var params = '?showTrainOperationInfo=false'
    if (this.props.location.state && this.props.location.state.referrerHash) {
      referrerHash = this.props.location.state.referrerHash
    }
    name = lineName == "nankai" ? "koya" : "nankai"
    if (this.props.showingNext && this.props.reverseFlag) {
      url = `/lines/${name}/trains${params}${referrerHash}`
      window.location.href = url
    } else if(this.props.showingNext && !this.props.reverseFlag) {
      name = lineName == "nankai" ? "nankai" : "koya"
      url = `/lines/${name}/trains${params}${referrerHash}`
      window.location.href = url
    } else{
      url = `/lines/${name}/train_operation_info`
    }
    this.props.history.push({
      pathname: `${url}`,
      state: { referrerHash: referrerHash },
    })
    this.props.nextNotification()
    this.props.lineReverse()
  }

  // フッター
  renderFooter() {

    return (
      <div className="c-Modal-footer">
        <a onClick={this.infoClick} className="c-Modal-operationInfoAgree">
          OK
        </a>
      </div>
    )
  }

  render() {
    const { lineName } = this.props.match.params
    const { notifications } = this.props

    if (!notifications) return null

    return (
      <div
        className={`c-Modal is_${lineName}`}
        onClick={ () => this.infoClick() }
      >
        <div
          className="c-Modal-dialog"
          onClick={(e) => e.stopPropagation()}
        >
          {this.renderHeader(lineName)}
          {this.renderModalBody()}
          {this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default TrainOperationInfo
